import React, { Component } from 'react';
import { connect, batch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { translation } from 'helpers/utilsHelper.js';
import { formatDate, substractDays, compareAsc } from 'helpers/datesHelper.js';
import { groupTransactionsByData } from 'helpers/transactionsHelper.js';
import transactionTypes from 'transactionTypes.enum.js';
import _map from 'lodash/map';
import _size from 'lodash/size';
import _some from 'lodash/some';
import _omit from 'lodash/omit';
import _find from 'lodash/find';
import _get from 'lodash/get';
import Loader from 'Loader.js';
import Pagination from 'Pagination.js';
import classNames from 'classnames';
import S from 'StyledAccountBetHistoryListView.js';
import {
  changeDateByType,
  changeActiveTab,
  changeActiveFilter,
  setCurrentPage,
  fetchTransactionsByFilter,
  fetchCashoutsMaximumAmount,
  resetBetHistoryList,
  refreshBetHistoryList,
  processCashoutAmount,
  processRebet,
  processLiveCurtainForTxId,
  toggleLiveCurtainForTxId,
} from 'accountBetHistoryActions.js';

import BetHistoryTransactionItem from 'BetHistoryTransactionItem.js';
import TvBetHistoryTransactionItem from 'TvBetHistoryTransactionItem.js';
import { toggleAccountModal } from 'accountActions.js';

class AccountBetHistoryListView extends Component {
  componentDidMount = async () => {
    const { fetchTransactionsByFilter } = this.props;

    try {
      await fetchTransactionsByFilter();
    } catch (error) {
      console.log('fetchTransactionsByFilter:' + error);
    }
  };

  handleChangeStart = (date) => {
    const { changeDateByType, fetchTransactionsByFilter } = this.props;
    const startDate = new Date(date);

    batch(() => {
      changeDateByType('startDate', startDate);
      fetchTransactionsByFilter();
    });
  };

  handleChangeEnd = (date) => {
    const { changeDateByType, fetchTransactionsByFilter } = this.props;
    const endDate = new Date(date);

    batch(() => {
      changeDateByType('endDate', endDate);
      fetchTransactionsByFilter();
    });
  };

  onChangeFilter = (activeTab) => {
    const { changeActiveTab, fetchTransactionsByFilter } = this.props;

    batch(() => {
      changeActiveTab(activeTab);
      fetchTransactionsByFilter();
    });
  };

  setStartDate = (days) => {
    const { changeDateByType, fetchTransactionsByFilter } = this.props;
    const today = new Date();
    const startDate = substractDays(today, days);
    const endDate = days == 1 ? startDate : today;

    batch(() => {
      changeDateByType('startDate', startDate);
      changeDateByType('endDate', endDate);
      fetchTransactionsByFilter();
    });
  };

  compareDates = (dateLeft, dateRight) => {
    dateLeft = new Date(formatDate(dateLeft, 'yyyy-MM-dd'));
    dateRight = new Date(formatDate(dateRight, 'yyyy-MM-dd'));
    const result = compareAsc(dateLeft, dateRight);
    return !result;
  };

  prepareCashout = async (slipId) => {
    const { fetchCashoutsMaximumAmount } = this.props;

    try {
      return await fetchCashoutsMaximumAmount(slipId);
    } catch (error) {
      throw error;
    }
  };

  processCashout = async (config, abortControllerSignal) => {
    const curtainDelay = async (delayMS) => {
      const p = new Promise((resolve, reject) => {
        delayMS = Number(delayMS);
        const timerId = setTimeout(resolve, delayMS);
        abortControllerSignal.addEventListener('abort', () => {
          clearTimeout(timerId);
          reject({ message: translation('account_cashoutForm_aborted') });
        });
      });
      return p;
    };

    const { processCashoutAmount, processLiveCurtainForTxId, transactionsList } = this.props;
    try {
      let slipId = _get(config, ['slipId']);
      let countDownRequired = _get(config, ['countDownRequired']);
      slipId = Number(slipId);

      const hasCashoutLiveCurtain =
        process.env.CASHOUT_LIVE_CURTAIN && JSON.parse(process.env.CASHOUT_LIVE_CURTAIN);
      if (hasCashoutLiveCurtain && countDownRequired) {
        const curtainData = _omit({ ...config }, ['slipId', 'type']);
        const delayMS = await processLiveCurtainForTxId(slipId, curtainData);
        await curtainDelay(delayMS);
        const result = await processCashoutAmount(config);
        return result;
      } else {
        const result = await processCashoutAmount(config);
        return result;
      }
    } catch (error) {
      throw error;
    }
  };

  processRebet = async (eventId) => {
    const { processRebet } = this.props;
    try {
      await processRebet(eventId);
    } catch (error) {
      throw error;
    }
  };

  renderTransactions = () => {
    const {
      currencyCode,
      transactionsList,
      cashouts,
      activeFreebets,
      refreshBetHistoryList,
      toggleLiveCurtainForTxId,
    } = this.props;

    let transactionsGroupedByData = groupTransactionsByData(transactionsList, 'regDate');

    let temporaryJscContainer = [];

    for (let property in transactionsGroupedByData) {
      temporaryJscContainer.push(
        <S.transactionDataHeader key={property}>
          <S.transactionDataHeaderInfo>
            <S.HeaderInfoRegData>{property}</S.HeaderInfoRegData>
            <S.HeaderInfoDataLabel>{translation('account_betHistory_stake')}</S.HeaderInfoDataLabel>
            <S.HeaderInfoDataLabel>{translation('account_betHistory_win')}</S.HeaderInfoDataLabel>
          </S.transactionDataHeaderInfo>
          {_map(transactionsGroupedByData[property], (transaction, index) => {
            const transactionItemProps = {
              index,
              currencyCode,
              transaction,
              transactionsList,
              cashouts,
              activeFreebets,
              refreshBetHistoryList,
              toggleLiveCurtainForTxId,
            };
            if (transactionTypes.TV_BET_TRANSACTIONS.indexOf(transaction.transactionType) > -1) {
              return (
                <TvBetHistoryTransactionItem
                  key={transaction.transactionId}
                  className="transaction-list-item"
                  {...transactionItemProps}
                  toggleAccountModal={toggleAccountModal}
                ></TvBetHistoryTransactionItem>
              );
            } else {
              return (
                <BetHistoryTransactionItem
                  key={transaction.transactionId}
                  className="transaction-list-item"
                  {...transactionItemProps}
                  prepareCashout={this.prepareCashout}
                  processCashout={this.processCashout}
                  processRebet={this.processRebet}
                  toggleAccountModal={toggleAccountModal}
                ></BetHistoryTransactionItem>
              );
            }
          })}
        </S.transactionDataHeader>
      );
    }

    return temporaryJscContainer;
  };

  goPage = (currentPage) => {
    const { fetchTransactionsByFilter, setCurrentPage } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage);
        fetchTransactionsByFilter();
      });
    } catch (error) {
      console.log('goPage:' + error);
    }
  };

  render() {
    const {
      isPending,
      activeTab,
      startDate,
      endDate,
      limit,
      transactionsList,
      currentPage,
      isNextPageAvailable,
    } = this.props;
    let transactionsJsx = [];
    //loop over sorted object with data, and then map single transactions
    if (transactionsList.length > 0) {
      transactionsJsx = this.renderTransactions();
    }
    const today = new Date();

    return (
      <S.AccountBetHistoryListView className="account-bet-history">
        <S.BetHistoryFiltersDates className="bet-history-filters-dates">
          <S.Datepicker>
            <S.DateLabel>{translation('common_dateFrom')}</S.DateLabel>
            <input
              type="date"
              value={formatDate(startDate, "yyyy-MM-dd")}
              onChange={(event) => this.handleChangeStart(event.target.value)}
            />
            <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
          </S.Datepicker>
          <S.Datepicker>
            <S.DateLabel>{translation('common_dateTo')}</S.DateLabel>
            <input
              type="date"
              value={formatDate(endDate, "yyyy-MM-dd")}
              onChange={(event) => this.handleChangeEnd(event.target.value)}
            />
            <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
          </S.Datepicker>
        </S.BetHistoryFiltersDates>

        <S.BetHistoryFilters className="bet-history-filters">
          <S.BetHistoryFiltersRow className="byTime">
            <S.BetHistoryFiltersBtns className="bet-history-btns-wrapper">
              <S.FilterBtn
                isActive={this.compareDates(startDate, today) && this.compareDates(endDate, today)}
                onClick={this.setStartDate.bind(this, 0)}
              >
                {translation('account_betHistory_range_today')}
              </S.FilterBtn>

              <S.FilterBtn
                isActive={
                  this.compareDates(startDate, substractDays(today, 1)) &&
                  this.compareDates(endDate, substractDays(today, 1))
                }
                onClick={this.setStartDate.bind(this, 1)}
              >
                {translation('account_betHistory_range_yesterday')}
              </S.FilterBtn>

              <S.FilterBtn
                isActive={
                  this.compareDates(startDate, substractDays(today, 7)) &&
                  this.compareDates(endDate, today)
                }
                onClick={this.setStartDate.bind(this, 7)}
              >
                {translation('account_betHistory_range_week')}
              </S.FilterBtn>

              <S.FilterBtn
                isActive={
                  this.compareDates(startDate, substractDays(today, 30)) &&
                  this.compareDates(endDate, today)
                }
                onClick={this.setStartDate.bind(this, 30)}
              >
                {translation('account_betHistory_range_month')}
              </S.FilterBtn>
            </S.BetHistoryFiltersBtns>
          </S.BetHistoryFiltersRow>
          <S.BetHistoryFiltersRow className="byStatus">
            <S.BetHistoryFiltersBtns className="bet-history-btns-wrapper">
              <S.FilterBtn
                onClick={this.onChangeFilter.bind(this, 'all')}
                className={classNames({ active: activeTab == 'all' })}
              >
                {translation('account_betHistory_types_all')}
              </S.FilterBtn>
              <S.FilterBtn
                onClick={this.onChangeFilter.bind(this, 'lost')}
                className={classNames({ active: activeTab == 'lost' })}
              >
                {translation('account_betHistory_types_lost')}
              </S.FilterBtn>
              <S.FilterBtn
                onClick={this.onChangeFilter.bind(this, 'won')}
                className={classNames({ active: activeTab == 'won' })}
              >
                {translation('account_betHistory_types_won')}
              </S.FilterBtn>
              <S.FilterBtn
                onClick={this.onChangeFilter.bind(this, 'undecided')}
                className={classNames({ active: activeTab == 'undecided' })}
              >
                {translation('account_betHistory_types_undecided')}
              </S.FilterBtn>
            </S.BetHistoryFiltersBtns>
          </S.BetHistoryFiltersRow>
        </S.BetHistoryFilters>

        <S.BetHistoryTransactions className="bet-history-transaction-list">
          {isPending ? (
            <Loader size="5" />
          ) : (
            <>
              <S.BetHistoryTransactionsList className="transaction-list">
                {_size(transactionsList) > 0 && transactionsJsx}

                {!_size(transactionsList) && (
                  <S.NoResult className="no-result">
                    {translation('account_betHistory_transfersNotFound')}
                  </S.NoResult>
                )}
              </S.BetHistoryTransactionsList>

              {_size(transactionsList) > 0 && (
                <Pagination
                  isNextPageAvailable={isNextPageAvailable}
                  currentPage={currentPage}
                  limit={limit}
                  data={transactionsList}
                  callback={this.goPage}
                />
              )}
            </>
          )}
        </S.BetHistoryTransactions>
      </S.AccountBetHistoryListView>
    );
  }
}

const mapStateToProps = ({
  AccountBetHistory: {
    isPending,
    error,
    startDate,
    endDate,
    limit,
    transactionsList,
    currentPage,
    activeTab,
    activeFilter,
    cashouts,
    isNextPageAvailable,
  },
  AccountFreebet: {
    freebets: {
      active: { data: activeFreebets },
    },
  },
  Auth: {
    user: { currencyCode },
  },
}) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    limit,
    currencyCode,
    activeTab,
    activeFilter,
    transactionsList,
    cashouts,
    activeFreebets,
    currentPage,
    isNextPageAvailable,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    changeActiveTab: bindActionCreators(changeActiveTab, dispatch),
    changeActiveFilter: bindActionCreators(changeActiveFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    changeDateByType: bindActionCreators(changeDateByType, dispatch),
    fetchTransactionsByFilter: bindActionCreators(fetchTransactionsByFilter, dispatch),
    fetchCashoutsMaximumAmount: bindActionCreators(fetchCashoutsMaximumAmount, dispatch),
    resetBetHistoryList: bindActionCreators(resetBetHistoryList, dispatch),
    refreshBetHistoryList: bindActionCreators(refreshBetHistoryList, dispatch),
    processCashoutAmount: bindActionCreators(processCashoutAmount, dispatch),
    processRebet: bindActionCreators(processRebet, dispatch),
    toggleAccountModal: bindActionCreators(toggleAccountModal, dispatch),
    processLiveCurtainForTxId: bindActionCreators(processLiveCurtainForTxId, dispatch),
    toggleLiveCurtainForTxId: bindActionCreators(toggleLiveCurtainForTxId, dispatch),
    dispatch,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccountBetHistoryListView));
